import {
  getDayjsObject,
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { setBookings } from "@/slices/bookingsSlice";
import { debounce } from "lodash";
import dayjs from "dayjs";

const VisitorInformation = ({ visitorInformationRef , formData, updateFormData}) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [form] = Form.useForm();
  const [vistiorInfomation, setVistiorInfomation] = useState(null);
  const isCancelled = bookings?.cancelled === true;

  useEffect(()=>{
    if(formData) {
      setVistiorInfomation(formData);
    }
  }, [formData]);

  useEffect(() => {
    if (bookings !== null) {
      const scheduledDateTime = getDayjsObject(
        bookings?.scheduledDate,
        bookings?.scheduledTime
      );
      console.log(
        "🚀 ~ VisitorInformation ~ scheduledDateTime:",
        scheduledDateTime
      );
      const arrivalDateTime = getDayjsObject(
        bookings?.arrivalDate,
        bookings?.arrivalTime
      );
      const departureDateTime = getDayjsObject(
        bookings?.departureDate,
        bookings?.departureTime
      );

      const cancellationDateTime = getDayjsObject(
        bookings?.cancellationDate,
        bookings?.cancellationTime
      );

      setVistiorInfomation({
        reasonForVisit: bookings?.reasonForVisit,
        location: isNonEmptyVariable(bookings?.location)
          ? parseInt(bookings?.location)
          : null,
        scheduledDateTime,
        arrivalDateTime,
        departureDateTime,
        cancellationDateTime,
        cancellationReason: bookings?.cancellationReason
          ? parseInt(bookings?.cancellationReason)
          : null,
            });
    } else {
      setVistiorInfomation(null);
    }
  }, [bookings]);

  useEffect(() => {
    if (vistiorInfomation !== null) {
      form.setFieldsValue(vistiorInfomation);
    } else {
      form.resetFields();
    }
  }, [vistiorInfomation]);

  const updateForm = (data) => {
    dispatch(
      setBookings({
        ...bookings,
        ...data,
      })
    );
  };

  const dataModify = debounce(() => {
    const values = form.getFieldsValue();

    values.scheduledDateTime = values?.scheduledDateTime
      ? dayjs(values?.scheduledDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    values.arrivalDateTime = values?.arrivalDateTime
      ? dayjs(values?.arrivalDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    values.departureDateTime = values?.departureDateTime
      ? dayjs(values?.departureDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    values.cancellationDateTime = values?.cancellationDateTime
      ? dayjs(values?.cancellationDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    const data = {
      ...values,
      scheduledDate: values?.scheduledDateTime?.split(" ")[0],
      scheduledTime: values?.scheduledDateTime?.split(" ")[1],
      arrivalDate: values?.arrivalDateTime?.split(" ")[0],
      arrivalTime: values?.arrivalDateTime?.split(" ")[1],
      departureDate: values?.departureDateTime?.split(" ")[0],
      departureTime: values?.departureDateTime?.split(" ")[1],
      cancellationDate: values?.cancellationDateTime?.split(" ")[0],
      cancellationTime: values?.cancellationDateTime?.split(" ")[1],
    };

    delete data?.scheduledDateTime;
    delete data?.arrivalDateTime;
    delete data?.departureDateTime;

    updateForm(data);
  }, 600);

  return (
    <Form
      form={form}
      initialValues={vistiorInfomation}
      ref={visitorInformationRef}
      onFieldsChange={() => {
        dataModify();
      }}
    >
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={6}>
          <FormItem name="reasonForVisit" label="Reason For Visit"
            rules={[
                {
                  required: true,
                  message: "You must enter the reason for visit",
                },
              ]}
          >
            <Select
              options={getOptionsFromRefList("Reason_For_Visit")}
              disabled={!bookingsFieldsEnabled}
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="location" label="Location">
            <Select
              options={getOptionsFromRefList(
                "Loan_Destination",
                false,
                false,
                true
              )}
              disabled={!bookingsFieldsEnabled}
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={12}></StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem name="scheduledDateTime" label="Scheduled Date/Time">
            <CommonDatePicker
              placeholder="MM/DD/YYYY HH:mm"
              format="MM/DD/YYYY HH:mm"
              disabled={!bookingsFieldsEnabled}
            />
          </FormItem>
        </StyledGridCol>
        {/* ARRIVAL & DEPARTURE – only when NOT cancelled */}
        {!isCancelled && (
          <>
            <StyledGridCol lg={8}>
              <FormItem name="arrivalDateTime" label="Arrival Date/Time">
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={8}>
              <FormItem name="departureDateTime" label="Departure Date/Time">
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </>
        )}
        {isCancelled && (
        <>
          <StyledGridCol lg={6}>
            <FormItem
              name="cancellationReason"
              label="Cancellation Reason"
              rules={
                isCancelled
                  ? [
                      {
                        required: true,
                        message: "You must select the reason for cancellation",
                      },
                    ]
                  : []
              }
            >
              <Select
                options={getOptionsFromRefList("Cancellation_Reason")}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={8}>
            <FormItem
              name="cancellationDateTime"
              label="Cancellation Date/Time"
              rules={isCancelled ? [
                {
                  required: true,
                  message: "You must enter cancellation date & time",
                },
              ] : []}
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disabled={true}
              />
            </FormItem>
          </StyledGridCol>
        </>
      )}
      </StyledGridRow>
    </Form>
  );
};

export default VisitorInformation;
